const getUser = () => {
  return JSON.parse(localStorage.getItem("webRtcUser"));
};

const setUser = (user) => {
  return localStorage.setItem("webRtcUser", JSON.stringify(user));
};

const removeUser = () => {
  return localStorage.removeItem("webRtcUser");
};

export { getUser, setUser, removeUser };
